module.exports = __webpack_public_path__ + "static/media/SimpleDumbbell.3153793f.glb";